import { BandChart, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const BandChartWrapper = styled.div<{ $color: string }>`
  & svg {
    height: 240px;
  }

  ${BandChart.Styled.LinePlot} {
    color: ${({ $color }) => $color};
    stroke-width: 1px;
  }
`;

export const ChartAndHorizonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ChartTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`;

export const ChartTitleText = styled.span`
  ${typographyV2.titleBase};
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`;

export const DescriptionText = styled.span`
  ${typographyV2.titleSm};
`;
